import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, Link, CircularProgress } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import Error from '../common/Error';

const styles = theme => ({
  root: {
    maxWidth: 700,
    marginTop: theme.spacing(3),
    overflowX: 'auto',
    margin: 'auto',
    padding: '5px'
  },
  table: {
    minWidth: 700
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 300
  }
});

function Summary(props) {
  const { classes } = props;

  const countMetricResult = useQuery(gql`
    query metricCountQuery {
      totalMetricCount
    }
  `);

  const countDatapointResult = useQuery(gql`
    query datapointCountQuery {
      totalDatapointCount
    }
  `);

  const renderMetricStats = ({ loading, error, data }) => {
    if (loading) return <CircularProgress />;
    if (error) return <Error />;
    return (
      <Typography>
        <strong>{data.totalMetricCount} </strong>
        <Link component={RouterLink} to='/metrics'>
          metrics
        </Link>
      </Typography>
    );
  };

  const renderDatapointStats = ({ loading, error, data }) => {
    if (loading) return <CircularProgress />;
    if (error) return <Error />;
    return (
      <Typography>
        <strong>{data.totalDatapointCount} </strong>datapoints
      </Typography>
    );
  };
  return (
    <Paper className={classes.root}>
      <Typography variant='h3' gutterBottom>
        System Stats
      </Typography>
      {renderMetricStats(countMetricResult)}
      {renderDatapointStats(countDatapointResult)}
    </Paper>
  );
}

export default withStyles(styles)(Summary);
